export enum DynamoColumn {
    Firmware = 1,
    Menu = 2,
};